import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import Vue from 'vue';

var files = require.context('./modules', false, /\.js$/);

files.keys().forEach(function (key) {
  var filterModule = files(key).default;

  for (var filterName in filterModule) {
    if (filterModule.hasOwnProperty(filterName)) {
      Vue.filter(filterName, filterModule[filterName]);
    }
  }
});